var btn = document.getElementById('cookie-dismiss');
var cookeiKey = 'cookiebar-dismissed';
if (btn) {
    if(getCookie(cookeiKey) === 'yes') {
        hideMessage();
    }
    btn.addEventListener('click', onClick);
}

function hideMessage() {
    document.getElementById('cookie').classList.add('-dismissed');
}

function saveSetting() {
    var TWELVE_WEEKS_MS = 1000 * 60 * 60 * 24 * 7 * 12;
    var expiry = new Date();
    expiry.setTime(expiry.getTime() + TWELVE_WEEKS_MS);
    document.cookie = `${cookeiKey}=yes; expires=${expiry}'; SameSite=strict`;
}

function getCookie(name) {
    vals = document.cookie.split('; ')
    var cookieObject = vals.reduce((acc, curr) => {
        var pair = curr.split('=');
        pair[0] = decodeURIComponent(pair[0]);
        pair[1] = decodeURIComponent(pair[1]);
        acc[pair[0]] = pair[1];
        return acc;
    }, {});

    return cookieObject[name];
}

function onClick(event) {
    hideMessage();
    saveSetting();
}